const EnumAPBTUV = 6 // UV属性绑定
const EnumKFTTReal2 = 2 // 二维向量(double2)类型
/**
 * 处理mixer和clip数据，clip使用nodeptr来保证唯一
 * @param {list} nodes node数据
 */
const formMixerClip = (nodesList, mixerName) => {
  const res = []
  for (let i = 0; i < nodesList.length; i += 1) {
    res.push({
      mixer: mixerName,
      clipName: nodesList[i].nodePtr,
    })
  }
  return res
}
/* 处理mixer和clip数据，clip使用nodeptr来保证唯一
 * @param {list} nodes node数据
 */
const formClipAction = (clipsList, mixerName) => {
  const res = []
  for (let i = 0; i < clipsList.length; i += 1) {
    res.push({
      mixer: mixerName,
      clip: clipsList[i],
    })
  }
  return res
}
/**
 * 批量向片段中添加轨道数据
 * @param {list} nodes node数据
 */
const formTracks = (nodesList, clips) => {
  const res = []
  for (let i = 0; i < nodesList.length; i += 1) {
    const tempObj = {
      node: nodesList[i].nodePtr,
      clip: clips[i],
      trackParam: {
        trackType: EnumKFTTReal2,
        propertyLinkType: EnumAPBTUV,
      },
    }
    res.push(tempObj)
  }
  return res
}
/**
 * 批量向片段中添加轨道数据
 * @param {list} nodesList node数据
 */
const formKeys = (nodesList, trackList) => {
  const res = []
  const lFlow = [
    [0, 0],
    [1, 0],
  ]
  const rFlow = [
    [1, 0],
    [0, 0],
  ]
  for (let i = 0; i < nodesList.length; i += 1) {
    const tempObj1 = {
      keyframeTrack: trackList[i],
      time: 0,
    }
    const tempObj2 = {
      keyframeTrack: trackList[i],
      time: nodesList[i].time,
    }
    if (_.toNumber(nodesList[i].direction) === 0) {
      tempObj1.value = lFlow[0]
      tempObj2.value = lFlow[1]
    } else {
      tempObj1.value = rFlow[0]
      tempObj2.value = rFlow[1]
    }
    res.push(tempObj1)
    res.push(tempObj2)
  }
  return res
}
/**
 * 批量向片段中添加轨道数据
 * @param {list} nodesList node数据
 */
const formLoops = (actionList, loop, repetition) => {
  const res = []
  for (let i = 0; i < actionList.length; i += 1) {
    res.push({
      action: actionList[i],
      loopMode: loop,
      repetitions: repetition,
    })
  }
  return res
}
const batchSetMaterial = (player, nodes, imagePath) => {
  // texture 设置材质
  const nodesList = _.map(nodes, (item) => {
    return { node: item.nodePtr, imagePath: imagePath || item.imagePath }
  })
  player.Native.NodeProxy.batchSetNodesTexture(nodesList)
  return true
}
/**
 * @param {obj} nodeInfo nodeptr，单个的node的信息
 * @param {obj} baseData 基础数据
 */
const batchNodesUV = async (currentMixer, player, nodes, isPlay, mixerName = 'uv') => {
  // // mixer clip action
  const mixer = currentMixer || (await player.Native.AnimationMixer.getMixer(mixerName))
  const mixerClipList = formMixerClip(nodes, mixer)
  const clipsList = await player.Native.AnimationClip.getBatchClips(mixerClipList)
  const clipActionList = formClipAction(clipsList, mixer)
  const actionList = await player.Native.AnimationAction.getBatchclipActions(clipActionList)
  // track
  const flagLength = 200
  if (clipsList.length > flagLength) {
    const loopNum = Math.ceil(clipsList.length / flagLength)
    for (let i = 0; i < loopNum; i += 1) {
      const el = clipsList.slice(i * flagLength, (i + 1) * flagLength)
      // eslint-disable-next-line no-await-in-loop
      await player.Native.KeyframeTrack.batchClearTrack(el)
    }
  } else {
    await player.Native.KeyframeTrack.batchClearTrack(clipsList) // 可能造成云渲染黑屏
  }
  const tracksParam = formTracks(nodes, clipsList)
  const trackList = await player.Native.KeyframeTrack.batchAddTracksWithParam(tracksParam)
  if (trackList.length > flagLength) {
    const loopNum = Math.ceil(trackList.length / flagLength)
    for (let i = 0; i < loopNum; i += 1) {
      const el = trackList.slice(i * flagLength, (i + 1) * flagLength)
      // eslint-disable-next-line no-await-in-loop
      await player.Native.KeyframeTrack.batchKeyClear(el)
    }
  } else {
    await player.Native.KeyframeTrack.batchKeyClear(trackList) // 可能造成云渲染黑屏
  }
  const trackkeysList = formKeys(nodes, trackList)
  if (trackkeysList.length > flagLength) {
    const loopNum = Math.ceil(trackkeysList.length / flagLength)
    for (let i = 0; i < loopNum; i += 1) {
      const el = trackkeysList.slice(i * flagLength, (i + 1) * flagLength)
      // eslint-disable-next-line no-await-in-loop
      await player.Native.KeyframeTrack.batchKeyAppend(el)
    }
  } else {
    await player.Native.KeyframeTrack.batchKeyAppend(trackkeysList)
  }
  // play
  const loops = formLoops(actionList, 1, -1)
  player.Native.AnimationAction.batchSetLoop(loops)
  if (isPlay) {
    player.Native.AnimationAction.batchPlay(actionList)
  }
  return {
    mixer,
    clipsList,
    actionList,
    isReady: true,
  }
}
/** 设置模型节点的液体流向效果
 * @description:
 * @param {*} player
 * @param {*} matUrl 材质文件路径
 * @param {*} currentPipeFlow 要加载的流体数据对象
 * @param {*} convertNodeList 流体模型node与item的映射表集合
 * @param {*} currentMixer 动画混合器
 * @return {*}
 */
const setFlowDirectionFun = async (
  player,
  matUrl,
  currentPipeFlow,
  convertNodeList,
  currentMixer,
  type
) => {
  // 设置节点的显影
  const itemInfo = await player.Native.ModelTree.findItemByName(
    currentPipeFlow.playerModelPipleName,
    0,
    true,
    3
  )
  await player.Native.ModelTree.setItemVisible(itemInfo.item, true)
  const currentNode = _.find(convertNodeList, ['item', itemInfo.item])
  let node = null
  if (!currentNode) {
    node = await player.Native.ModelTree.convertToNode(itemInfo.item, false, false) // 将PR节点转化成Node
    await player.Native.ModelTree.createNodeItem(itemInfo.parentItem, node, true, false) // 为Node创建树节点并绑定
    convertNodeList.push({
      item: itemInfo.item,
      nodePtr: node,
    })
  } else if (type) {
    node = currentNode.nodePtr
  } else {
    await player.Native.NodeProxy.setNodeVisible(currentNode.nodePtr, true) // 设置node节点显示
    await player.Native.ModelTree.setItemVisible(currentNode.item, false) // 设置模型树节点影藏
    return
  }
  await player.Native.NodeProxy.setNodeVisible(node, true) // 设置节点显示隐藏状态
  await player.Native.ModelTree.setItemVisible(itemInfo.item, false) // 设置节点可见性
  // 设置流动效果
  // 获取节点子级
  const nodeChildren = await player.Native.NodeProxy.getNodeChildrenRecursion(node)
  const currentNodeList = []
  for (let i = 0; i < nodeChildren.length; i += 1) {
    const e = nodeChildren[i]
    if (e.nodePtr) {
      // 模型名称前面带/的都是kks不需要设置材质
      const nodeReplaceList = e.name.split('/')
      if (nodeReplaceList[0] || !e.name) {
        currentNodeList.push({
          ...e,
          direction: currentPipeFlow.flowDirection,
          time: _.round(100 / currentPipeFlow.speed, 2),
          imagePath: matUrl,
        })
        // }
      }
    }
  }
  batchSetMaterial(player, currentNodeList, matUrl)
  const { mixer } = await batchNodesUV(
    currentMixer,
    player,
    currentNodeList,
    currentPipeFlow.flowState === 0
  )
  currentMixer = mixer
}
/**
 * @description: 关闭/显示流向的操作
 * @param {*} player
 * @param {*} playerModelPipleName 流向模型的名称
 * @param {*} convertNodeList 流体模型node与item的映射表集合
 * @param {*} flag 显示还是关闭流向
 * @return {*}
 */
const closeOrShowFlowDirectionFun = async (player, playerModelPipleName, convertNodeList, flag) => {
  const itemInfo = await player.Native.ModelTree.findItemByName(playerModelPipleName, 0, true, 3)
  const currentNode = _.find(convertNodeList, ['item', itemInfo.item])
  if (currentNode) {
    await player.Native.NodeProxy.setNodeVisible(currentNode.nodePtr, flag) // 设置node节点影藏显示
    await player.Native.ModelTree.setItemVisible(currentNode.item, !flag) // 设置模型树节点隐藏显示
  }
}
export {
  batchNodesUV,
  batchSetMaterial,
  formMixerClip,
  formClipAction,
  formTracks,
  formKeys,
  formLoops,
  setFlowDirectionFun,
  closeOrShowFlowDirectionFun,
}
